import { useTypedQuery } from "hooks";
import { UsersDashboardQueryKeys } from "modules/UsersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

type AssignedAppointmentsCount = {
  is_dayplanner_enabled?: boolean;
  user_id?: number | null;
  isMechanicRole?: boolean;
  dealer_location_id?: number | null;
};

export const useAssignedAppointmentsCountQuery = ({ is_dayplanner_enabled, dealer_location_id, isMechanicRole, user_id }: AssignedAppointmentsCount) =>
  useTypedQuery({
    queryKey: UsersDashboardQueryKeys.assignedAppointmentsCount,
    queryFn: async () =>
      (
        await ApiInstance.post(
          UsersDashboardQueryKeys.assignedAppointmentsCount.endpoint,
          { user_id, dealer_location_id },
          UsersDashboardQueryKeys.assignedAppointmentsCount.baseUrl
        )
      ).data.count,
    enabled: is_dayplanner_enabled && Boolean(user_id && dealer_location_id && isMechanicRole)
  });
